import styled from 'styled-components';

import { blueSphera, graySphera, whiteSphera } from 'src/utilities/UIStyles/variables/Colors';

import { fadeIn, fadeOut } from 'src/utilities/animations';

export const ModalSuccessWithdrawVirtualAccount = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  visibility: ${(props) => (props.showModalSuccessWithdrawVirtualAccount ? 'visible' : 'hidden')};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgb(0, 0, 0, 0.5);
  z-index: 100;
  animation: ${(props) => (props.showModalSuccessWithdrawVirtualAccount ? fadeIn : fadeOut)} 0.5s
    linear;
  transition: all 0.5s;

  > div {
    width: 40%;
    background-color: ${whiteSphera};
    border-radius: 5px;
    padding-top: 1%;
    padding-bottom: 2.5%;

    > div:nth-child(1) {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding-bottom: 2.5%;
      border-bottom: 1px solid #b7bcc7;

      > h3 {
        font-size: 1.5vw;
        color: ${graySphera};
        width: 90%;
        padding-left: 5%;
      }

      > figure {
        width: 25px;
        height: 25px;
        cursor: pointer;

        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > div:nth-child(1) {
        > h3 {
        }

        > figure {
          > img {
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    > div {
      width: 90%;
      padding-top: 5%;
      padding-bottom: 5%;

      > div:nth-child(1) {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        padding-bottom: 5%;
        border-bottom: 1px solid #b7bcc7;

        > h3 {
          font-size: 4.5vw;
        }

        > figure {
          > img {
          }
        }
      }
    }
  }
`;

export const DetailSuccessWithdrawVirtualAccount = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 2.5%;
  padding-left: 5%;

  > div {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 90%;
    margin: 2.5% auto 5% auto;

    > figure {
      width: 80px;
      height: 80px;

      > img {
        width: 100%;
        height: 100%;
      }
    }

    > p {
      color: ${graySphera};
      font-size: 1.2vw;
      width: 50%;
    }
  }

  > a {
    color: ${whiteSphera};
    font-weight: bold;
    font-size: 1.2vw;
    text-decoration: none;
    text-align: center;
    line-height: 50px;
    width: 30%;
    height: 50px;
    margin: auto;
    border: none;
    border-radius: 5px;
    background-color: ${blueSphera};
    cursor: pointer;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > figure {
        > img {
        }
      }

      > p {
      }
    }

    > a {
    }
  }

  @media (max-width: 600px) {
    padding-top: 5%;
    padding-left: 0;

    > div {
      width: 100%;

      > figure {
        width: 60px;
        height: 60px;

        > img {
        }
      }

      > p {
        font-size: 4.2vw;
        width: 70%;
      }
    }

    > a {
      font-size: 4.2vw;
      width: 90%;
    }
  }
`;
